<div *ngIf="user">
    <form class="form" name="userEditForm" [formGroup]="form.form">

        <div class="user-edit-form">
            <mat-form-field appearance="outline">
                <mat-label>Username</mat-label>
                <input matInput placeholder="Username" [formControl]="form.controls.username" required
                    [readonly]="readOnlyAttr">
                <user-edit-error matError [control]="form.controls.username" name="username"></user-edit-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>First name</mat-label>
                <input matInput placeholder="First name" [formControl]="form.controls.firstName" required
                    [readonly]="readOnlyAttr">
                <user-edit-error matError [control]="form.controls.firstName" name="firstName"></user-edit-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Last name</mat-label>
                <input matInput placeholder="Last name" [formControl]="form.controls.lastName" required
                    [readonly]="readOnlyAttr">
                <user-edit-error matError [control]="form.controls.lastName" name="lastName"></user-edit-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Work Phone</mat-label>
                <input matInput placeholder="Work Phone" [formControl]="form.controls.workPhone" required>
                <user-edit-error matError [control]="form.controls.workPhone" name="workPhone"></user-edit-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Mobile Phone</mat-label>
                <input matInput placeholder="Mobile Phone" [formControl]="form.controls.mobilePhone" required>
                <user-edit-error matError [control]="form.controls.mobilePhone" name="mobilePhone"></user-edit-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Enter your email</mat-label>
                <input matInput placeholder="Enter your email" [formControl]="form.controls.email" required>
                <user-edit-error matError [control]="form.controls.email" name="email"></user-edit-error>
            </mat-form-field>

            <div *ngIf="isMyself(); then thenBlock else elseBlock"></div>
                <ng-template #thenBlock>
                    <input matInput placeholder="Menu role" readonly value="{{roleName}}" name="roleName" id="roleName" />
                    <div class="checkbox-group" formGroupName="compliancePayload">
                    <input matInput placeholder="Compliance roles" disabled>
                    <mat-checkbox  disabled [checked]="isComplianceUser()">DCM CORP</mat-checkbox>
                    <mat-checkbox  disabled [checked]="isComplianceUser()">HMEX</mat-checkbox>
                    <mat-checkbox  disabled [checked]="isComplianceUser()">HME</mat-checkbox>
                    <mat-checkbox  disabled [checked]="isComplianceUser()">HMEC</mat-checkbox>
                    </div>
                    <!-- <mat-icon>done</mat-icon>&nbsp;
                    <span>Compliance admin rights</span> -->
                </ng-template>
                <ng-template #elseBlock>
                    <code-name-select [items]="menuRoles" [selectedItemSubject]="selectedItemSubject" [label]="'Menu role'" style="margin-right: 23px">
                    style="margin-right: 23px">
                    </code-name-select>
                    <div formGroupName="compliancePayload" class="checkbox-group">
                    <input matInput placeholder="Compliance roles" disabled>
                    <mat-checkbox color="primary" formControlName="compliance1" >DCM CORP</mat-checkbox>
                    <mat-checkbox color="primary" formControlName="compliance2" >HMEX</mat-checkbox>
                    <mat-checkbox color="primary" formControlName="compliance3" >HME</mat-checkbox>
                    <mat-checkbox color="primary" formControlName="compliance4" >HMEC</mat-checkbox>
                    </div>
                </ng-template>
            </div>

        <mat-divider class="form-divider"></mat-divider>

        <div class="meta-data-container">
            <mat-form-field appearance="outline">
                <mat-label>Created by</mat-label>
                <input matInput [value]="createdBy" disabled>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Changed by</mat-label>
                <input matInput [value]="changedBy" disabled>
            </mat-form-field>
            <br />

            <mat-form-field appearance="outline">
                <mat-label>Version</mat-label>
                <input matInput [value]="user.version" disabled>
            </mat-form-field>

            <mat-checkbox id="inactive" color="primary" formControlName="inactive">Inactive user</mat-checkbox>
            <br>
            <mat-checkbox id="invite" color="primary" [formControl]="sendEmailInvite">Send email invite</mat-checkbox>

        </div>

        <br />

        <mat-divider class="form-divider"></mat-divider>

        <div class="user-edit-buttons">
            <button type="submit" mat-raised-button (click)="saveUser()" color="primary"
                [disabled]="(form.form.dirty || sendEmailInvite.value === true) || !form.valid ? null: true">Save</button>
            <button type="button" mat-raised-button (click)="cancel()">Cancel</button>
            <button type="button" mat-raised-button (click)="reset()">Undo</button>
        </div>
    </form>
</div>